(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/react/components/exclusions-survey.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/react/components/exclusions-survey.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  ReactBottomSheet = _svs$ui.ReactBottomSheet;
const _svs$ui$ReactForm = svs.ui.ReactForm,
  ControlGroup = _svs$ui$ReactForm.ControlGroup,
  Option = _svs$ui$ReactForm.Option,
  Checkbox = _svs$ui$ReactForm.Checkbox;
const _React = React,
  useState = _React.useState;
const trackInteraction = (e, forms, action) => {
  const arrayForms = Array.from(forms);
  let checked = arrayForms.filter(element => element.checked).map(element => element.id).toString();
  if (action === 'Closed') {
    checked = '-1';
  }
  e === null || e === void 0 || e.preventDefault();
  svs.components.analytics.trackEvent({
    action,
    category: 'ExclusionSurvey',
    opt_label: checked
  });
};
const texts = ['Jag har förlorat för mycket pengar', 'Jag har lagt för mycket tid på mitt spelande', 'Jag har haft svårt att planera mitt spelande', 'Annan orsak'];
const Sheet = () => {
  const _useState = useState(texts.map((text, idx) => ({
      id: idx + 1,
      checked: false,
      text
    }))),
    _useState2 = _slicedToArray(_useState, 2),
    checkedItems = _useState2[0],
    setCheckedItems = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmitted = _useState4[0],
    setIsSubmitted = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    showSheet = _useState6[0],
    setShowSheet = _useState6[1];
  const setCheckbox = id => {
    setCheckedItems(prev => prev.map(item => item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
      checked: !item.checked
    }) : item));
  };

  const onBottomSheetStateChange = state => {
    if (state.state === 'closed') {
      trackInteraction(null, checkedItems, 'Closed');
    }
  };
  return React.createElement(React.Fragment, null, React.createElement(ReactBottomSheet.BottomSheet, {
    behavior: "modal",
    headerTitle: "Varf\xF6r tog du en spelpaus?",
    isExpanded: true,
    isVisible: showSheet,
    onStateChange: state => {
      onBottomSheetStateChange(state);
    }
  }, React.createElement("p", {
    className: "padding-left-2 padding-top-2",
    style: {
      fontWeight: '500',
      fontSize: '17.5px'
    }
  }, "V\xE4lj ett eller flera alternativ"), React.createElement("div", {
    className: "padding-left-2"
  }, React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja ett alternativ",
    hasError: isSubmitted && !checkedItems.some(item => item.checked),
    v2: true
  }, checkedItems.map(checkedItem => React.createElement("div", {
    className: "padding-bottom-1",
    key: checkedItem.id
  }, React.createElement(Checkbox, {
    checked: checkedItem.checked,
    key: checkedItem.id,
    name: "question",
    onChange: () => setCheckbox(checkedItem.id),
    value: checkedItem.id
  }, checkedItem.text))), React.createElement(Option, null))), React.createElement(Option, null), React.createElement(ReactBottomSheet.BottomSheetFooter, {
    className: ""
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: e => {
      setIsSubmitted(true);
      if (checkedItems.some(item => item.checked)) {
        trackInteraction(e, checkedItems, 'Submit');
        setShowSheet(false);
      }
    }
  }, "Spara"))));
};
const ExclusionsSurvey = () => {
  const isMobile = svs.core.detect.formfactor.mobile();
  if (isMobile) {
    const el = document.getElementById('self-exclusion-overview');
    if (el && !document.getElementById('sheet-component')) {
      var _document$querySelect;
      const mountPoint = document.createElement('div');
      mountPoint.id = 'sheet-component';
      (_document$querySelect = document.querySelector('.js-react-container')) === null || _document$querySelect === void 0 || _document$querySelect.appendChild(mountPoint);
      ReactDOM.render(React.createElement(Sheet, null), mountPoint);
    }
    return;
  }
  const dialog = new svs.ui.dialog.Confirm({
    actions: [{
      title: 'Stäng',
      callback: (e, forms) => {
        trackInteraction(e, forms, 'Closed');
        dialog.close();
      }
    }, {
      callback: (e, forms) => {
        trackInteraction(e, forms, 'Submit');
        dialog.close();
      },
      title: 'Spara'
    }],
    area: svs.ui.dialog.area.POPUP,
    branding: svs.ui.dialog.branding.SPORT,
    icon: 'spelpaus',
    message: [{
      align: svs.ui.dialog.message.align.LEFT,
      text: '<h4>Välj ett eller flera alternativ</h4>',
      type: svs.ui.dialog.message.TEXT
    }, ...texts.map(text => ({
      align: svs.ui.dialog.message.align.LEFT,
      text,
      type: svs.ui.dialog.message.CHECKBOX,
      block: true
    }))],
    title: 'Varför tog du en spelpaus?'
  });
  svs.ui.dialog.api.add(dialog);
};
svs.accountservices.player_exclusions.ExclusionsSurvey = ExclusionsSurvey;

 })(window);